"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTOPLAY_BEHAVIOR = void 0;
var AUTOPLAY_BEHAVIOR = {
  SPIN_X: 'spin-x',
  SPIN_Y: 'spin-y',
  SPIN_XY: 'spin-xy',
  SPIN_YX: 'spin-yx'
};
exports.AUTOPLAY_BEHAVIOR = AUTOPLAY_BEHAVIOR;